import Reflux from 'reflux';

export default Reflux.createActions({
    "login": {},
    "checkLogin": {},
    "updateCorrelativos": {},
    "getCliente": {},
    "register": {},
    "getTotals": {},
    "getUser": {},
    "putUser": {},
    "newPago": {},
    "solicitar": {}
});


/** WEBPACK FOOTER **
 ** ./app-react/reflux/AuthActions.js
 **/